import Address from '@passkeys/ui/address';
import Badge from '@passkeys/ui/badge';
import Icon from '@passkeys/ui/icon';

import { cn } from '@/ui/utils/classnames';

export interface CopyableAddressProps {
  address: string;
  copied: boolean;
}

function CopyableAddress({ address, copied }: CopyableAddressProps) {
  return (
    <div className="relative">
      <div
        className={cn(
          'flex items-center gap-x-1 transition-opacity duration-300',
          copied && 'opacity-0',
        )}
      >
        <Address
          address={address}
          className="text-xs"
          dataTestId="copyable-address"
          length={8}
        />
        <Icon
          name="copy-filled"
          size={12}
          className="mr-2 text-gray-500 theme-dark:text-neutral-400"
        />
      </div>
      <Badge
        className={cn(
          'absolute right-0 top-[-4px] transition-opacity duration-300',
          !copied && 'opacity-0',
        )}
        suffix={<Icon name="copy-filled-check" size={12} />}
      >
        Copied
      </Badge>
    </div>
  );
}

export default CopyableAddress;
